import styles from './header.module.scss';

const Header = () => {
    return (
        <>
            <div className={styles.container} />
        </>
    );
};

export default Header;
